<mat-toolbar class="p-0 mat-elevation-z1">
    <div style="width: 63%;" >
        <marquee behavior="scroll" direction="" *ngIf="!isAdmin">
            <ol>
                <li *ngFor="let item of instructionDetail"><span>{{item.description}}</span></li>
            </ol>
        </marquee>
    </div>
    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && !rightNavbar"
                (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="/assets/images/logos/Group.svg">
                </div>
            </div>
        </div>

        <!-- <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center"> -->

        <!-- <button type="button" pButton icon="pi pi-list" label="Show" ></button> -->

        <!-- <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
            <button mat-button class="notification"  type="button">
                <i class="pi pi-envelope p-text-secondary" pBadge style="font-size: 2rem" (click)="menu.toggle($event)" severity="danger" value="2"></i>
            </button> -->
        <!-- <p-menu #menu [popup]="true" [model]="userCompany"></p-menu> -->
        <!-- <button  mat-button class="notification" class="pi pi-envelope p-text-secondary" pBadge (click)="op.toggle($event)"
            >
            <i class="pi pi-envelope p-text-secondary" pBadge style="font-size: 2rem"  severity="danger" value="2"></i></button> -->

        <!-- </div> -->
        <!-- <p-menu #menu [popup]="true" ></p-menu> -->
        <!-- </div> -->
        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <button label="Back to account" pButton pRipple type="button" *ngIf="loginAsUser"
                class="p-button-raised p-button-danger p-mr-4 " icon="pi pi-sign-out" (click)="backToMyAccount()">
            </button>
            <button mat-button class="notification" type="button" (click)="op.toggle($event);">
                <i class="pi pi-bell p-text-secondary isactive-class" pBadge style="font-size: 2rem" severity="danger"
                    [value]="!notificationLength ? '0' : notificationLength"></i>
            </button>

            <p-overlayPanel #op appendTo="body" styleClass="message-body" (onShow)="onNotificationClick()">
                <ng-template pTemplate>
                    <p-panel>
                        <ng-template pTemplate="header">
                            <div class="p-d-flex p-ai-center p-jc-between header-width">
                                <h5>Notifications</h5>
                                <span class="p-buttonset">

                                    <button pButton pRipple label="Active" (click)="getAllNoticationByUserId(true)"
                                        [ngClass]="isActive == true ? 'isactive' : 'isactive-not'"></button>
                                    <button pButton pRipple label="Archive" (click)="getAllNoticationByUserId(false)"
                                        [ngClass]="isActive == false ? 'isactive' : 'isactive-not'"></button>
                                </span>
                                <div style="width: 60px;">
                                    <a href="javascript:void(0)" label="read" (click)="markdata()"
                                        [ngClass]="this.allNotification.length <= 0 ? 'none' : 'block'"
                                        *ngIf="isActive">Read
                                        All</a>
                                </div>

                            </div>
                        </ng-template>
                        <ng-template pTemplate="body">
                            <div class="overflow-data">
                                <div *ngFor="let notification of allNotification" class="message-header">
                                    <div class="p-field p-grid">
                                        <!-- <div class="p-col-2">
                                            <img [src]="notification.icon ? notification.icon : 'https://image.flaticon.com/icons/png/512/1077/1077221.png'"
                                                shape="circle" class="imageDisplay radious"
                                                onerror="this.src='https://image.flaticon.com/icons/png/512/1077/1077221.png'" />
                                        </div> -->
                                        <div class="p-col-9 border-message"
                                            [ngClass]="isArchive == false ? 'notification-header' : ' ' "
                                            (click)="!isArchive && redirect(notification)">
                                            <h5 class="text-bold">{{notification.title}}</h5>
                                            <div>{{notification.body}}</div>
                                            <div class="date-message">{{notification.createdOn | date:dateTimeformat}}
                                            </div>
                                        </div>
                                        <div class="p-col-1" *ngIf="isActive">
                                            <span pTooltip="Mark as read" tooltipPosition="left">
                                                <button (click)="readNotification(notification.id)" class="read" pButton
                                                    pRipple type="button"></button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </p-panel>


                </ng-template>
            </p-overlayPanel>


            <div class="toolbar-separator"></div>

            <button *ngIf="userCompany.length > 1" mat-button fxHide fxShow.gt-xs class="language-button"
                [matMenuTriggerFor]="companyMenu">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="iso text-capitalize">{{selectedCompany}}</span>
                    <mat-icon class="s-16 ml-4" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>


            <mat-menu #companyMenu="matMenu" [overlapTrigger]="false">
                <button mat-menu-item (click)="onCompanyChange(0)">
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <span class="iso">All Companies </span>
                    </span>
                </button>
                <button mat-menu-item *ngFor="let item of userCompany" (click)="onCompanyChange(item.id)">
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <span class="iso">{{item.companyName}}</span>
                    </span>
                </button>
            </mat-menu>


            <div class="toolbar-separator"></div>

            <!-- <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img [src]="GetprofileImage ? GetprofileImage : 'assets/images/avatars/profile4.png'"
                        class="avatar mr-0 mr-sm-16" onerror="this.src='assets/images/avatars/profile4.png'" />

                    <span class="username mr-12 text-capitalize" fxHide fxShow.gt-sm>{{userName}}</span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item (click)="myprofile()" *ngIf="!isAdmin ">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>

                    <span>My Profile</span>
                </button>
                <button mat-menu-item (click)="changeuser()">
                    <mat-icon matSuffix class="secondary-text">account_box</mat-icon>

                    <span>Change Username</span>
                </button>
                <button mat-menu-item (click)="changePass()">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>

                    <span>Change Password</span>
                </button>


                <button mat-menu-item class="" (click)="onLogout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Logout</span>
                </button>

            </mat-menu> -->

            <!-- <div class="toolbar-separator"></div>

            <fuse-search-bar (input)="search($event)"></fuse-search-bar>

            <div class="toolbar-separator"></div> -->

            <!-- <button mat-button fxHide fxShow.gt-xs
                    class="language-button"
                    [matMenuTriggerFor]="languageMenu">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="flag mr-8" [src]="'assets/icons/flags/'+selectedLanguage.flag+'.png'">
                    <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
                </div>
            </button>

            <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <img class="flag mr-16" [src]="'assets/icons/flags/'+lang.flag+'.png'">
                        <span class="iso">{{lang.title}}</span>
                    </span>
                </button>

            </mat-menu>

            <div class="toolbar-separator" fxHide fxShow.gt-xs></div> -->

            <!-- <button mat-icon-button
                    class="quick-panel-toggle-button"
                    (click)="toggleSidebarOpen('quickPanel')"
                    aria-label="Toggle quick panel">
                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button> -->

        </div>

    </div>
    <p-confirmDialog [style]="{width: '450px'}" appendTo="body"></p-confirmDialog>
</mat-toolbar>